import type { ModuleConfig } from './types'

/**
 * Identity helper for type inference on module manifests. Modules should
 * `export default defineModule({ ... })` so `import.meta.glob`'s
 * `import: 'default'` produces a typed ModuleConfig.
 *
 * Validation (unique ids, no shortcut collisions, kebab-case) runs at
 * registry build time — not here — so this function stays free of
 * side effects.
 */
export function defineModule(config: ModuleConfig): ModuleConfig {
  return config
}
